import { getBondingTokenPrice } from '@cronos-app/api';
import { type ChainId, utils } from '@cronos-app/sdk';

import type { TokenOption, TokenPriceFetcher } from '../types';
import { isBondingToken } from '../types';

export const bondingTokenFetcher = (chainId: ChainId): TokenPriceFetcher => ({
  fetchPrice: async (token: TokenOption) => {
    if (!isBondingToken(token))
      throw new Error('Token is not an bonding token');
    return getBondingTokenPrice(
      utils.getLayerOfChain(chainId),
      token.bondingAddress,
    );
  },
  supportsToken: (token: TokenOption) => isBondingToken(token),
});
